import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const Renderer = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "forge-renderer" */ './renderer')),
    LoadingSkeleton: () => null,
});
